import { render, staticRenderFns } from "./LinkAttachmentsDialog.vue?vue&type=template&id=ffca4d08"
import script from "./LinkAttachmentsDialog.vue?vue&type=script&lang=js"
export * from "./LinkAttachmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports